import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./class-history.css";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { IoMdAnalytics } from "react-icons/io";
import { useNavigate } from "react-router-dom";
let ClassHistory = () => {
  const navigate = useNavigate();
  let handleDropdownChange = (e) => {
    if (e.target.value === "View") {
      navigate("/class-history/view");
    }
  };
  let State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  let [TableData, setTableData] = useState([
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Willow Anderson",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 5,
      status: "Complated",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 5,
      status: "Complated",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 6,
      status: "Rejected",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 5,
      status: "Complated",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 6,
      status: "Rejected",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 5,
      status: "Complated",
    },
    {
      classTitle: "Lorem ipsum",
      classGrade: "class 1A",
      description: "Lorem ipsum dolor...",
      TutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      totalHours: 6,
      status: "Rejected",
    },
  ]);
  let handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };
  return (
    <SideMenu>
      <div className="page-container">
        <div className="page-header-button-main">
          <Button className="page-header-button" variant="text">
            <p className="page-header-button-text">Download</p>
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by course Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by course Name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Search by Tutor</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by tutor"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Class History</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="class-history-table-id-heading">ID</th>
                <th className="class-history-table-image-heading">Image</th>
                <th className="class-history-table-class-title-heading">
                  Class Title
                </th>
                <th className="class-history-table-class-grade-heading">
                  Class Grade/Division
                </th>
                <th className="class-history-table-description-heading">
                  Discription
                </th>
                <th className="class-history-table-tutors-name-heading">
                  Tutors Name
                </th>
                <th className="class-history-table-student-no-heading">
                  No. of Students
                </th>
                <th className="class-history-table-country-heading">Country</th>
                <th className="class-history-table-state-heading">State</th>
                <th className="class-history-table-date-heading">Date</th>
                <th className="class-history-table-duration-heading">
                  Total Hour
                </th>
                <th className="class-history-table-status-heading">Status</th>
                <th className="class-history-table-action-heading"></th>
                <th className="class-history-table-analytics-heading"></th>
              </tr>
              </thead>
              <br />
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex+1}</td>
                    <td>
                      <img src={ProfileImg} className="table-image" />
                    </td>
                    <td className="table-data">{tableValue.classTitle}</td>
                    <td className="table-center-data">{tableValue.classGrade}</td>
                    <td className="table-data">{tableValue.description}</td>
                    <td className="table-data">{tableValue.TutorName}</td>
                    <td className="table-center-data">{tableValue.noOfStudents}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-center-data">{tableValue.totalHours}h</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Rejected"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Rejected"
                              ? "#B80000"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Complated"
                          selected={
                            tableValue.status === "Complated" && "selected"
                          }
                        >
                          Complated
                        </option>
                        <option
                          value="Rejected"
                          selected={
                            tableValue.status === "Rejected" && "selected"
                          }
                        >
                          Rejected
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={handleDropdownChange}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/class-history/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default ClassHistory;
